import React from 'react';
import { useEditor, useNode } from '@craftjs/core';

import EmailEditorSection from './EmailEditorSection';
import EmailEditorContentElement from './EmailEditorContentElement';
import EmailEditorTag from './EmailEditorTag';

import {
  EmailEditorSectionSetting,
  EmailEditorContentSettings,
} from '../settings';

import { useEmailEditorContext } from '../../controllers/context';
import { EMAIL_EDITOR_BLANK_CONTENT_PLACEHOLDER } from 'static/Constants';
import EmailEditorInlineText from './EmailEditorInlineText';

const EmailEditorFreeText = (props) => {
  const { id } = useNode();
  const { actions } = useEditor();
  const { template } = useEmailEditorContext();
  const { text } = props;

  const onChangeContent = ({ value, index }) => {
    actions.history
      .throttle()
      .setProp(id, (props) => (props.text[index] = value));
  };

  const content =
    template?.id === 1 ? (
      <>
        <EmailEditorInlineText
          content={text[0]}
          onChangeContent={(value) => onChangeContent({ value, index: 0 })}
        />
        <EmailEditorTag tag='projectName' />{' '}
        <EmailEditorInlineText
          content={text[1]}
          onChangeContent={(value) => onChangeContent({ value, index: 1 })}
        />
        <EmailEditorTag tag='numberSample' />{' '}
        <EmailEditorInlineText
          content={text[2]}
          onChangeContent={(value) => onChangeContent({ value, index: 2 })}
        />
      </>
    ) : (
      <>
        <span>{EMAIL_EDITOR_BLANK_CONTENT_PLACEHOLDER} </span>
        <EmailEditorTag tag='projectName' />{' '}
        {EMAIL_EDITOR_BLANK_CONTENT_PLACEHOLDER}
        <EmailEditorTag tag='numberSample' />{' '}
      </>
    );

  return (
    <EmailEditorSectionSetting settings={<EmailEditorContentSettings />}>
      <EmailEditorSection tags={['projectName', 'numberSample']}>
        <EmailEditorContentElement content={content} />
      </EmailEditorSection>
    </EmailEditorSectionSetting>
  );
};

EmailEditorFreeText.craft = {
  displayName: 'Content',
  props: {
    text: '',
    settings: {
      bold: false,
      italic: false,
      underLine: false,
      fontSize: 14,
      color: '#333',
    },
  },
  custom: { tags: ['projectName', 'numberSample'] },
};

export default EmailEditorFreeText;
